import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { camelToTitleCase } from "@bloglovin/vue-framework";

export default class IconSize extends BaseOption {
  static userInterfaceComponent = (optionValues, themeId) => {
    let suffix = "px";
    const selectOptions = [];

    if (themeId !== undefined) {
      themeStructure.size.icon.forEach(size => {
        let pixelValue = BaseOption._getStyleValuePropertiesFromTheme("size.icon", themeId)[size];

        selectOptions.push({
          value: size,
          label: camelToTitleCase(size),
          secondaryLabel: pixelValue,
        });

        if (optionValues["default.icon-size"] === size) {
          suffix = pixelValue;
        }
      });
    }

    return {
      label: "Icon Size",
      component: inspectorTools.AUTOCOMPLETE,
      props: {
        allowCustomValue: true,
        showAllResultsOnClick: true,
        suffix: suffix,
        items: selectOptions,
      },
    };
  };

  static defaultValue = "standard";
}
